export default "__VITE_ASSET__mLMh345c__"